module.exports = __webpack_public_path__ + "img/icon2.068f5915.png";